import React, { Suspense, useState } from "react";
import { Switch, Router } from "react-router-dom";
import { renderRouteHome, renderRouteHomeV2 } from "../routers";
import history from "../routerHistory";

import { ResetCSS } from "@edricphan2022/uikit";
import GlobalStyle from "../style";

const App = () => {
  const [show, setShow] = useState(false);

  return (
    <Router history={history}>
      <ResetCSS />
      <GlobalStyle />
      <Switch>
        <Suspense fallback={null}>
          {/* Edric custom router */}
          {renderRouteHome()}
          {renderRouteHomeV2()}
        </Suspense>
      </Switch>
    </Router>
  );
};

export default App;
